(() => {
  function initPairWith(root) {
    if (!root || root.dataset.pairWithInitialized === 'true') return;
    root.dataset.pairWithInitialized = 'true';

    const productCards = Array.from(root.querySelectorAll('.pair-with__item'));
    const listEl = root.querySelector('.pair-with__list');
    const modal = root.querySelector('[data-pair-with-modal]');
    const prevArrow = root.querySelector('[data-pair-with-prev]');
    const nextArrow = root.querySelector('[data-pair-with-next]');
    const variantSelect = root.querySelector('[data-pair-with-variant-select]');
    const modalProductTitle = root.querySelector('[data-modal-product-title]');
    const errorEl = root.querySelector('[data-pair-with-error]');
    const confirmBtn = root.querySelector('[data-confirm-pair-with]');
    const closeModalBtn = root.querySelector('[data-close-pair-with-modal]');
    let selectedVariantId = null;

    const shouldUseSlider = Number(listEl?.dataset.pairWithCount || 0) > 2;

    // ─── Index-based native scroll ────────────────────────────────────────
    let currentIndex = 0;

    function getSlidesVisible() {
      if (window.innerWidth >= 550) return 3;
      if (window.innerWidth >= 380) return 2;
      return 1;
    }

    function scrollToIndex(index) {
      if (!listEl || !productCards.length) return;
      const maxIndex = Math.max(0, productCards.length - getSlidesVisible());
      currentIndex = Math.max(0, Math.min(index, maxIndex));

      const cardWidth = productCards[0].offsetWidth;
      const gap = parseFloat(getComputedStyle(listEl).columnGap) || 16;
      listEl.scrollTo({ left: currentIndex * (cardWidth + gap), behavior: 'smooth' });
    }

    // ─── Slick slider ─────────────────────────────────────────────────────
    function enableNativeScrollFallback() {
      if (!listEl) return;
      listEl.classList.add('pair-with__list--scroll-fallback');
    }

    function initSlickSlider(attempt = 0) {
      if (!shouldUseSlider || !listEl) return;

      if (window.jQuery && typeof window.jQuery.fn.slick === 'function') {
        if (!window.jQuery(listEl).hasClass('slick-initialized')) {
          listEl.classList.remove('pair-with__list--scroll-fallback');
          window.jQuery(listEl).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            arrows: false,
            adaptiveHeight: true,
            responsive: [
              { breakpoint: 550, settings: { slidesToShow: 2 } },
              { breakpoint: 380, settings: { slidesToShow: 1 } }
            ]
          });
        }
        return;
      }

      if (attempt < 20) {
        window.setTimeout(() => initSlickSlider(attempt + 1), 200);
      } else {
        enableNativeScrollFallback();
      }
    }

    if (shouldUseSlider) {
      enableNativeScrollFallback();
      initSlickSlider();
      window.addEventListener('load', () => initSlickSlider(), { once: true });
    }

    // ─── Arrow navigation ─────────────────────────────────────────────────
    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        if (window.jQuery && listEl && window.jQuery(listEl).hasClass('slick-initialized')) {
          window.jQuery(listEl).slick('slickPrev');
        } else {
          scrollToIndex(currentIndex - 1);
        }
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        if (window.jQuery && listEl && window.jQuery(listEl).hasClass('slick-initialized')) {
          window.jQuery(listEl).slick('slickNext');
        } else {
          scrollToIndex(currentIndex + 1);
        }
      });
    }

    // ─── Cart ─────────────────────────────────────────────────────────────
    async function refreshCartUi() {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));

      const drawer = document.querySelector('.js-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true }));
      }
    }

    async function addVariantToCart(variantId, triggerButton) {
      if (!variantId) return;

      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.classList.add('is-loading');
        triggerButton.setAttribute('aria-busy', 'true');
      }

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data?.description || data?.message || 'Unable to add this item.');
        }

        if (modal && typeof modal.close === 'function' && modal.open) {
          modal.close();
        }

        await refreshCartUi();
      } catch (error) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = error.message || 'Unable to add this item.';
        }
      } finally {
        if (triggerButton) {
          triggerButton.disabled = false;
          triggerButton.classList.remove('is-loading');
          triggerButton.removeAttribute('aria-busy');
        }
      }
    }

    // ─── Variant modal ────────────────────────────────────────────────────
    function openVariantModal(productData) {
      if (!modal || !variantSelect) return;

      const availableVariants = (productData.variants || []).filter((v) => v.available);
      variantSelect.innerHTML = '';
      selectedVariantId = null;

      availableVariants.forEach((variant, index) => {
        const option = document.createElement('option');
        option.value = String(variant.id);
        option.textContent = variant.title;
        variantSelect.appendChild(option);
        if (index === 0) selectedVariantId = variant.id;
      });

      modalProductTitle.textContent = productData.title || '';
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      }
    }

    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => { selectedVariantId = e.target.value; });
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', () => addVariantToCart(selectedVariantId, confirmBtn));
    }

    if (closeModalBtn) {
      closeModalBtn.addEventListener('click', () => { if (modal?.open) modal.close(); });
    }

    if (modal) {
      modal.addEventListener('click', (e) => { if (e.target === modal) modal.close(); });
    }

    productCards.forEach((card) => {
      const addBtn = card.querySelector('[data-add-pair-with]');
      const productJsonEl = card.querySelector('[data-product-json]');
      if (!addBtn || !productJsonEl) return;

      let productData = null;
      try {
        productData = JSON.parse(productJsonEl.textContent);
      } catch (_e) {
        productData = null;
      }
      if (!productData) return;

      addBtn.addEventListener('click', () => {
        const available = (productData.variants || []).filter((v) => v.available);
        if (available.length === 0) return;
        if (available.length === 1) {
          addVariantToCart(available[0].id, addBtn);
          return;
        }
        openVariantModal(productData);
      });
    });
  }

  function initAllPairWith() {
    document.querySelectorAll('.pair-with').forEach((s) => initPairWith(s));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllPairWith);
  } else {
    initAllPairWith();
  }

  document.addEventListener('shopify:section:load', initAllPairWith);
})();
